import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	OneToMany,
} from 'typeorm';
import { BaseEntity } from './base.entity';
import { ObjectFieldEntity } from './object-field.entity';
import { PublicUserSelectableResourceEntity } from './public-user-selectable-resource.entity';

@Index('_fk__object_field__id', ['fkObjectFieldId'], {})
@Index('unique_selectable_resource', ['name'], { unique: true })
@Entity('_selectable_resource_configuration')
export class SelectableResourceConfigurationEntity extends BaseEntity {
	@Column('int', {
		name: '_fk__object_field__id',
		nullable: true,
		unsigned: true,
	})
	public fkObjectFieldId!: number | null;

	@Column('varchar', {
		name: '_name',
		nullable: true,
		unique: true,
		length: 50,
	})
	public name!: string | null;

	@OneToMany(
		() => PublicUserSelectableResourceEntity,
		(publicUserSelectableResource) =>
			publicUserSelectableResource.fkSelectableResourceConfiguration,
		{},
	)
	public publicUserSelectableResources!: Array<PublicUserSelectableResourceEntity>;

	@ManyToOne(
		() => ObjectFieldEntity,
		(objectField) => objectField.selectableResourceConfigurations,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([{ name: '_fk__object_field__id', referencedColumnName: 'id' }])
	public fkObjectField!: ObjectFieldEntity;
}
